document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('form#CoursePage-form');

    const submitFilters = function () {
        let formData = new FormData(form);
        document.querySelectorAll('.CoursePage-filters [data-filter-address][data-active]').forEach((element) => {
            formData.append('address[]', element.dataset.filterAddress);
        })
        document.querySelectorAll('.CoursePage-filters [data-filter-specialization][data-active]').forEach((element) => {
            formData.append('specialization[]', element.dataset.filterSpecialization);
        })
        formData.append('sort', document.querySelector('.CoursePage-order [data-sort].active').dataset.sort);

        // mozno odeslat na pozadi s podporou strankovani nebo standardne pomoci JS
        for (let [key, value] of formData.entries()) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = value;
            form.appendChild(input);
        }
        form.submit();
    };

    document.querySelectorAll('.CoursePage-filters [data-filter-address]').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            el.toggleAttribute('data-active');
            submitFilters();
        })
    })

    document.querySelectorAll('.CoursePage-filters [data-filter-specialization]').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            el.toggleAttribute('data-active');
            submitFilters();
        })
    })

    document.querySelectorAll('.CoursePage-order [data-sort]').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            document.querySelectorAll('.CoursePage-order [data-sort]').forEach((element) => {
                element.classList.remove('active');
            })
            el.classList.add('active');
            submitFilters();
        })
    })

})